import { graphql } from '~publish/graphql'

import { useTypedMutation } from '../../hooks/useTypedMutation'

export const RejectPost = graphql(/* GraphQL */ `
  mutation RejectPost($id: PostId!) {
    rejectPost(input: { id: $id }) {
      __typename
      ... on MutationError {
        message
      }
      ... on PostActionSuccess {
        post {
          id
          status
          dueAt
        }
      }
    }
  }
`)

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const useRejectPost = () =>
  useTypedMutation(RejectPost, (data) => data.rejectPost, {
    refetchQueries: ['GetPostList'],
    successTypename: 'PostActionSuccess',
  })
